<template>
    <div
        class="l-navbar__wrapper"
        :class="{
            'l-navbar__wrapper--fixed': scroll > 0,
            'l-navbar__wrapper--home': isFrontPage
         }"
         v-click-outside="hideOnClick"
    >
        <nav
            role="navigation"
            aria-label="main navigation"
            class="l-navbar"
        >
            <div class="l-navbar__brand">
                <a
                    href="/"
                    class="l-navbar__brandLogo"
                >
                    <svg width="180" height="57" viewBox="0 0 180 57" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)" fill="#fff"><path d="M76.717 15.387h2.739v22.14h-2.739V34.82c-1.37 2.127-3.423 3.094-6.064 3.094-2.25 0-4.108-.773-5.77-2.417-1.565-1.644-2.348-3.577-2.348-5.898 0-2.32.783-4.254 2.347-5.897 1.565-1.644 3.521-2.417 5.771-2.417 2.64 0 4.695 1.063 6.064 3.094v-8.992zm-5.77 19.917c1.662 0 2.934-.58 4.107-1.644 1.076-1.063 1.663-2.417 1.663-4.06 0-1.644-.587-2.998-1.663-4.061-1.076-1.064-2.445-1.644-4.108-1.644-1.564 0-2.934.58-4.01 1.644-1.075 1.063-1.662 2.417-1.662 4.06 0 1.644.587 2.997 1.662 4.061a5.572 5.572 0 004.01 1.644zM85.52 30.856c.293 1.45.978 2.514 1.956 3.287 1.076.774 2.347 1.16 3.814 1.16 2.152 0 3.619-.773 4.597-2.32l2.347 1.354c-1.565 2.417-3.912 3.577-7.042 3.577-2.543 0-4.597-.773-6.162-2.32-1.564-1.547-2.347-3.578-2.347-5.995 0-2.417.783-4.35 2.347-5.994 1.565-1.547 3.62-2.417 6.064-2.417 2.348 0 4.304.774 5.77 2.417 1.468 1.644 2.25 3.577 2.25 5.898 0 .386 0 .773-.097 1.257H85.519v.096zm5.574-6.96c-1.467 0-2.738.386-3.716 1.256-.978.87-1.565 1.934-1.859 3.384H96.18c-.195-1.45-.88-2.61-1.76-3.384-.978-.87-2.054-1.257-3.326-1.257zM119.36 21.285c1.761 0 3.228.58 4.402 1.74 1.076 1.16 1.662 2.707 1.662 4.64v9.862h-2.738v-9.765c0-1.256-.294-2.127-.978-2.803-.685-.677-1.467-.967-2.543-.967-1.174 0-2.152.387-2.837 1.16-.684.773-1.075 2.03-1.075 3.674v8.798h-2.837v-9.862c0-1.256-.293-2.127-.88-2.803-.587-.677-1.467-.967-2.445-.967-1.174 0-2.152.387-2.934 1.16-.783.773-1.174 2.03-1.174 3.577v8.798h-2.739V21.672h2.739v2.127c1.076-1.644 2.641-2.514 4.792-2.514 2.152 0 3.717.87 4.695 2.707.978-1.837 2.641-2.707 4.89-2.707zM131.195 30.856c.293 1.45.978 2.514 1.956 3.287 1.076.774 2.347 1.16 3.814 1.16 2.152 0 3.619-.773 4.597-2.32l2.348 1.354c-1.565 2.417-3.913 3.577-7.042 3.577-2.543 0-4.597-.773-6.162-2.32-1.565-1.547-2.348-3.578-2.348-5.995 0-2.417.783-4.35 2.348-5.994 1.565-1.547 3.619-2.417 6.064-2.417 2.347 0 4.303.774 5.77 2.417 1.467 1.644 2.25 3.577 2.25 5.898 0 .386 0 .773-.098 1.257h-13.497v.096zm5.477-6.96c-1.467 0-2.739.386-3.717 1.256-.978.87-1.565 1.934-1.858 3.384h10.661c-.196-1.45-.88-2.61-1.761-3.384-.88-.87-2.054-1.257-3.325-1.257zM155.744 21.285c1.858 0 3.423.58 4.499 1.74 1.174 1.16 1.663 2.804 1.663 4.738v9.764h-2.739v-9.571c0-1.257-.391-2.32-1.076-2.997-.684-.677-1.662-1.064-2.934-1.064-1.369 0-2.543.387-3.325 1.257-.783.87-1.272 2.224-1.272 3.964v8.411h-2.738V21.672h2.738v2.32c1.076-1.837 2.837-2.707 5.184-2.707zM174.034 24.379h-4.304v8.604c0 .774.196 1.354.489 1.644.294.29.783.483 1.468.483h2.347v2.514c-2.445.29-4.206.097-5.379-.58-1.174-.677-1.663-2.03-1.663-3.964v-8.701h-3.13v-2.707h3.13v-3.578l2.738-.87v4.448h4.304v2.707zM178.142 18.771c-.489 0-.978-.193-1.37-.58-.391-.387-.586-.773-.586-1.257 0-.483.195-.967.586-1.354.392-.386.783-.58 1.37-.58.489 0 .978.194 1.271.58.391.387.587.774.587 1.354 0 .483-.196.967-.587 1.257-.391.29-.782.58-1.271.58zm-1.37 18.756V21.672h2.739v15.855h-2.739z"/></g><path d="M37.74 38.42c5.583-5.693 5.583-14.923 0-20.616a14.1 14.1 0 00-20.215 0c-5.583 5.693-5.583 14.923 0 20.615a14.1 14.1 0 0020.215 0z" stroke="#fff" stroke-opacity=".5" stroke-width=".5" stroke-miterlimit="10"/><path d="M33.08 33.667c3.009-3.068 3.009-8.043 0-11.11a7.6 7.6 0 00-10.895 0c-3.009 3.068-3.009 8.042 0 11.11a7.6 7.6 0 0010.895 0zM3.741 24.363l27.567 28.112M8.401 19.611l27.567 28.112M19.231 8.567L46.798 36.68M23.891 3.815l27.567 28.112M31.308 3.748L3.676 31.927M35.968 8.5L8.336 36.68" stroke="#fff" stroke-opacity=".5" stroke-width=".5" stroke-miterlimit="10"/><path d="M46.864 19.611L22.775 44.176l-3.544 3.614M51.523 24.363l-27.632 28.18" stroke="#fff" stroke-opacity=".5" stroke-width=".5" stroke-miterlimit="10"/><path d="M25.794 50.601l1.838-1.874 10.107-10.308c5.58-5.689 5.58-14.926 0-20.615a14.106 14.106 0 00-20.215 0l-5.448 5.556-6.498 6.626 1.838-1.874m22.053 12.985L14.9 26.237m-.066 3.816l7.285-7.43a7.58 7.58 0 0110.896 0c3.019 3.08 3.019 8.032 0 11.111l-7.286 7.43M5.578 26.238l6.498 6.626 10.895 11.11 6.498 6.627L5.58 26.238z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/><defs><clipPath id="clip0"><path fill="#fff" transform="translate(62.535 15.097)" d="M0 0h117.465v22.817H0z"/></clipPath></defs></svg>
                </a>
            </div>
            <div class="l-navbar__burgerWrapper">
                <div
                    class="l-navbar__burger"
                    :class="{'l-navbar__burger--active':showMenu}"
                    @click="showMenu = !showMenu"

                ></div>
            </div>
            <transition name="fade" mode="out-in">
                <div
                    class="l-navbar__menu"
                    :class="{'l-navbar__menu--mobile':showMenu}"
                >
                    <div class="l-navbar__end l-navbar__items">
                        <router-link
                            v-for="item in mainMenu"
                            :key="item.el"
                            class="l-navbar__item"
                            exact-active-class="l-navbar__item--active"
                            :to="item.url"
                            @click.native="hideOnClick"
                        >
                            {{ item.title }}
                        </router-link>
                    </div>
                </div>
            </transition>
        </nav>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
    directives: {
        ClickOutside
    },
    data() {
        return {
            scroll: null,
            showMenu: true
        }
    },
    computed: {
        mainMenu() {
            return this.$store.getters.getMainMenu
        },
        logo() {
            return this.$store.getters.getOptionsLogo
        },
        languages() {
            return this.$store.getters.getLanguages
        },
        locale() {
            return this.$store.getters.getLocale
        },
        isFrontPage() {
            return this.$route.path === '/'
        }
    },
    methods: {
        handleScroll() {
            this.scroll = window.scrollY
        },
        languageHome(locale) {
            return this.languages.find(lang => lang.lang === locale).home_url
        },
        handleResize() {
            if(window.innerWidth <= 1024) {
                this.showMenu = false
            } else {
                this.showMenu = true
            }
            // calc real document height
            document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
        },
        hideOnClick() {
            if(window.innerWidth <= 1024) {
                this.showMenu = false
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>
